import { createV2EventTracker } from '../util';
import { DatatableAnalytics, DatatableViewedAnalytics } from './types';

export const trackDatatableViewed =
  createV2EventTracker<DatatableViewedAnalytics>('Datatable Viewed');
export const trackDatatableSaved = createV2EventTracker<DatatableAnalytics>('Datatable Saved');
